import { DashboardNowResponse, DashboardReceivedResponse, DashboardSalesResponse, } from '@aeris/contracts';
import { clientTimeZone, request } from "./client.js";
export const fetchSalesDashboard = async (filter, signal) => {
    const params = new URLSearchParams({
        from: filter.from,
        to: filter.to,
        timeZone: clientTimeZone(),
    });
    if (filter.branchId !== undefined)
        params.set('branchId', filter.branchId);
    return DashboardSalesResponse.parse(await request(`/api/v1/dashboard/sales?${params.toString()}`, {
        ...(signal ? { signal } : {}),
    }));
};
export const fetchNowDashboard = async (filter = {}, signal) => {
    const params = new URLSearchParams({ timeZone: clientTimeZone() });
    if (filter.branchId !== undefined)
        params.set('branchId', filter.branchId);
    return DashboardNowResponse.parse(await request(`/api/v1/dashboard/now?${params.toString()}`, {
        ...(signal ? { signal } : {}),
    }));
};
/** Quem pagou, por forma, no mesmo período do painel (F217). */
export const fetchReceivedEntries = async (filter, signal) => {
    const params = new URLSearchParams({
        from: filter.from,
        to: filter.to,
        timeZone: clientTimeZone(),
    });
    if (filter.branchId !== undefined)
        params.set('branchId', filter.branchId);
    return DashboardReceivedResponse.parse(await request(`/api/v1/dashboard/received?${params.toString()}`, {
        ...(signal ? { signal } : {}),
    }));
};
//# sourceMappingURL=dashboard.js.map